<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="filters.storer.id" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-date-range-picker v-model="dateRange" :autoClose="false" clearable placeholder="business.label.date" showConfirmButton type="date" @clear="refresh" @confirm="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow:true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="storer.name" title="business.label.storer" width="300"/>
        <vxe-column field="balance.balanceDate" title="business.label.date" width="150"/>
        <vxe-column field="numberOfLocations" title="business.label.numberOfLocations" width="150"/>
        <vxe-column field="numberOfContainers" title="business.label.numberOfContainers" width="150"/>
        <vxe-column field="numberOfFixedLocations" title="business.label.numberOfFixedLocations" width="150"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import moment from 'moment'

export default {
  name: 'BalanceStatistics',
  data() {
    return {
      loading: false,
      data: [],
      storers: [],
      filters: new InventoryFactoryView(),
      dateRange: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  created() {
    Promise.all([
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storers = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      })
    ]).then(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'storer.id': this.filters.storer.id,
        dateFilter: { start: this.dateRange[0], end: this.dateRange[1] }
      }
      findAll('balanceStatisticsFactory', args, this.page, this.size).then((res) => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.dateRange = [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')]
      this.data = []
      this.page = 1
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>